import { useTheme } from '../lib/theme';

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  return (
    <label className="theme-control" title="Tema do site">
      <span className="sr-only">Escolher tema</span>
      <select value={theme} onChange={(event) => setTheme(event.target.value as 'light' | 'dark' | 'system')} aria-label="Tema do site">
        <option value="system">Sistema</option>
        <option value="dark">Escuro</option>
        <option value="light">Claro</option>
      </select>
    </label>
  );
}
